(function () {
  function initScroller(section) {
    var scroller = section.querySelector('.cac-cat-scroller');
    var prevBtn = section.querySelector('.cac-cat-arrow-prev');
    var nextBtn = section.querySelector('.cac-cat-arrow-next');
    var fade = section.querySelector('.cac-cat-fade');
    if (!scroller) return;

    function scrollByCard(direction) {
      var card = scroller.querySelector('.cac-cat-card');
      var cardWidth = card ? card.getBoundingClientRect().width + 20 : 220;
      scroller.scrollBy({ left: direction * cardWidth * 2, behavior: 'smooth' });
    }

    function updateFade() {
      if (!fade) return;
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var nearEnd = scroller.scrollLeft >= maxScroll - 8;
      var noOverflow = maxScroll <= 4;
      fade.classList.toggle('is-hidden', nearEnd || noOverflow);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    scroller.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);
    updateFade();
  }

  function initAll() {
    document.querySelectorAll('.cac-cat-outer').forEach(initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.cac-cat-outer') || e.target;
    if (section) initScroller(section);
  });
})();